var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[(_vm.isMobileLayout)?_c('layout-mobile',[_c('leads-page-content')],1):_c('layout-page',[_c('leads-page-content')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }